import { BaseFetch } from "../main-model"
export default class AssessStudentModel extends BaseFetch {
  getAssessStudentBy = (data) =>
    this.authFetch({
      url: "assess-student/getAssessStudentBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getAssessStudentById = (data) =>
    this.authFetch({
      url: "assess-student/getAssessStudentById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateAssessStudentById = (data) =>
    this.authFetch({
      url: "assess-student/updateAssessStudentById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertAssessStudent = (data) =>
    this.authFetch({
      url: "assess-student/insertAssessStudent",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteAssessStudentById = (data) =>
    this.authFetch({
      url: "assess-student/deleteAssessStudentById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
